import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
  AfterViewInit,
  Renderer2,
  ElementRef,
  AfterViewChecked,
} from '@angular/core';
import { SearchRequest, SelectedFacets } from '@usf/product-types';
import { FilterRequestModel } from 'src/app/search/shared/models/filter-request-model';
import { EndecaSearchPagesTypes } from '../../../../../shared/constants/endeca-search-pages-types';
import { ChipTypeEnum } from '@app/shared-product/components/usf-chip/models/chip-type.enum';

@Component({
  selector: 'app-selected-filters',
  templateUrl: './selected-filters.component.html',
  styleUrls: ['./selected-filters.component.scss'],
})
export class SelectedFiltersComponent
  implements OnInit, OnChanges, AfterViewChecked
{
  @Input() selectedFilters: SelectedFacets;
  @Input() searchRequest: SearchRequest;
  @Output()
  unselectFacet: EventEmitter<FilterRequestModel> = new EventEmitter();
  selectedRangeFilter: string;

  chipTypeEnum = ChipTypeEnum;
  constructor(
    private ref: ElementRef,
    private renderer: Renderer2,
  ) {}

  ngAfterViewChecked(): void {
    const refinementSection =
      this.ref?.nativeElement.parentNode.querySelector('.refinement');
    if (!!refinementSection) {
      const selectedFilters = this.ref?.nativeElement.querySelector('section');
      if (refinementSection && selectedFilters) {
        this.renderer?.setStyle(
          refinementSection,
          'max-height',
          document.body.clientHeight -
            selectedFilters.clientHeight -
            250 +
            'px',
        );
      }
    }
  }

  ngOnInit() {
    this.selectedRangeFilter = (
      this.searchRequest as FilterRequestModel
    )?.rangeSelectedFilter;
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.selectedRangeFilter = (
      this.searchRequest as FilterRequestModel
    )?.rangeSelectedFilter;
  }

  unselectFacetItem(item: string) {
    const urlSearchParams = new URLSearchParams(item);
    const dimensionIds = urlSearchParams.get('N');
    const searchFilterProperties = !!dimensionIds ? dimensionIds : '0';
    this.searchRequest = { ...this.searchRequest, searchFilterProperties };
    this.unselectFacet.emit({ ...this.searchRequest, brandName: null });
  }

  unselectRangeFilter() {
    const rangeRefinements = null;
    this.searchRequest = { ...this.searchRequest, rangeRefinements };
    this.unselectFacet.emit({
      ...this.searchRequest,
      rangeSelectedFilter: null,
    });
  }

  clearAllFilters() {
    let pageType = !!this.searchRequest.pageType
      ? this.searchRequest.pageType
      : null;
    if (
      !!this.searchRequest.pageType &&
      this.searchRequest.pageType != EndecaSearchPagesTypes.search
    ) {
      pageType = EndecaSearchPagesTypes.all;
    }

    this.searchRequest = {
      ...this.searchRequest,
      pageType,
      searchFilterProperties: null,
      rangeRefinements: null,
    };
    this.unselectFacet.emit({
      ...this.searchRequest,
      categoryId: '0',
      rangeSelectedFilter: null,
      brandName: null,
    });
  }
}
